/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassroomdisciplineIdLangsCulture202,
  PutApiV1ClassroomdisciplineIdLangsCulture400,
  PutApiV1ClassroomdisciplineIdLangsCulture401,
  PutApiV1ClassroomdisciplineIdLangsCulture404,
  PutApiV1ClassroomdisciplineIdLangsCultureMutationRequest,
  PutApiV1ClassroomdisciplineIdLangsCultureMutationResponse,
  PutApiV1ClassroomdisciplineIdLangsCulturePathParams,
} from "../../types/classPlanningLangController/PutApiV1ClassroomdisciplineIdLangsCulture.ts";
import { upsertClassroomDisciplineLangViewModelSchema } from "../upsertClassroomDisciplineLangViewModelSchema.ts";

export const putApiV1ClassroomdisciplineIdLangsCulturePathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    culture: z.string(),
  }) as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsCulturePathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ClassroomdisciplineIdLangsCulture202Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsCulture202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassroomdisciplineIdLangsCulture400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsCulture400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassroomdisciplineIdLangsCulture401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsCulture401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassroomdisciplineIdLangsCulture404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsCulture404>;

export const putApiV1ClassroomdisciplineIdLangsCultureMutationRequestSchema =
  z.lazy(
    () => upsertClassroomDisciplineLangViewModelSchema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsCultureMutationRequest>;

export const putApiV1ClassroomdisciplineIdLangsCultureMutationResponseSchema =
  z.lazy(
    () => putApiV1ClassroomdisciplineIdLangsCulture202Schema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdLangsCultureMutationResponse>;
